import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
// import { route } from "ziggy-js"
export const useCategoryLandingStore = defineStore('categoryLanding', ()=>{
    let builderCategories = ref([])
    let childCategories = ref([])
    const setBuilderCategories = (categories: any) => {
        builderCategories.value = categories
    }

    const setChildCategories = (categories: any) => {
        childCategories.value = categories
    }

    let launcherCategories = computed(()=>{

        return childCategories.value.map(cat => {
            let builderContent = builderCategories.value.find(builderCat => builderCat.name == cat.seo_name);
            return {
                headline: cat.category_name,
                image: builderContent?.landingLauncherImage ?? null,
                image_alt: cat?.category_name,
                cta: {
                    type: "button",
                    label: "Shop All",
                    url: {
                        urlType: 'product',
                        productUrl: {
                            seoName: cat.seo_name,
                            productType: 'category',
                            shopAll: true
                        }
                    }
                }
            }
        })
    })

    let missingImages = computed(()=>{
        return launcherCategories.value.every(cat => cat.image == null)
    });

    return {
        builderCategories,
        childCategories,
        setBuilderCategories,
        setChildCategories,
        launcherCategories,
        missingImages
    }
})